// extracted by mini-css-extract-plugin
export default {"label":"Labeled_label__iaduk","required":"Labeled_required__UJa-v"};